import React, { useState } from "react";
import {
  Button,
  makeStyles,
  Tooltip,
  useTheme,
  useMediaQuery,
  Fab,
  Zoom,
} from "@material-ui/core";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import ImageToPortraitDialog from "./ImageToPortraitDialog";

const useStyles = makeStyles((theme) => ({
  // Desktop button styles
  portraitButton: {
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(2),
    backgroundColor: "#4caf50", // Green color to differentiate from the blue upload button
    color: theme.palette.common.white,
    textTransform: "none",
    fontWeight: 500,
    padding: theme.spacing(1.5, 3),
    display: "flex",
    alignItems: "center",
    borderRadius: 28,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#43a047", // Slightly darker on hover
      boxShadow: "0 3px 6px rgba(0, 0, 0, 0.15)",
      transform: "translateY(-1px)",
    },
    "&:active": {
      transform: "translateY(0)",
      boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide on mobile (we'll use FAB instead)
    },
  },
  // Mobile FAB styles
  fabButton: {
    display: "none", // Hidden on desktop
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      backgroundColor: "#4caf50",
      color: theme.palette.common.white,
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      "&:hover": {
        backgroundColor: "#43a047",
      },
      padding: theme.spacing(1.5),
    },
  },
  fabExtended: {
    [theme.breakpoints.down("sm")]: {
      width: "auto",
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      borderRadius: 50,
    },
  },
  fabIcon: {
    marginRight: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(1),
    fontSize: "1.4rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.2rem",
    },
  },
}));

export default function ImageToPortraitButton() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isExtraSmall = useMediaQuery(theme.breakpoints.down("xs"));
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <>
      {/* Desktop Button */}
      <Tooltip
        title="Upload a photo to generate professional portrait variations for your LinkedIn, resume, or professional profiles."
        arrow
        placement="top"
      >
        <Button
          id="portrait-button"
          variant="contained"
          className={classes.portraitButton}
          onClick={handleOpenDialog}
          startIcon={<PhotoCameraIcon className={classes.icon} />}
          aria-label="Generate professional portraits"
        >
          Generate Professional Portraits
        </Button>
      </Tooltip>

      {/* Mobile FAB Button */}
      <Zoom in={isMobile}>
        <Tooltip title="Generate professional portraits" arrow placement="top">
          <Fab
            variant="extended"
            color="primary"
            aria-label="Generate portraits"
            className={`${classes.fabButton} ${classes.fabExtended}`}
            onClick={handleOpenDialog}
            style={{ backgroundColor: "#4caf50" }}
          >
            <PhotoCameraIcon className={classes.fabIcon} />
            {isExtraSmall ? "Portraits" : "Professional Portraits"}
          </Fab>
        </Tooltip>
      </Zoom>

      {/* Portrait Generation Dialog */}
      <ImageToPortraitDialog open={dialogOpen} onClose={handleCloseDialog} />
    </>
  );
}
